import 'isomorphic-fetch'

import { concessionFiltersEndpoint } from '~apiConfig'
import { getApiResponseInJSON, getIdToken } from '~utils'

import { resolveConcessionLocationTitle } from './concessionFiltersAdminValidation'

const getActiveFilterOptions = (filters = {}, filterKey) =>
  (filters?.[filterKey]?.options || [])
    .filter(option => option.is_active !== false)
    .map(({ key, label }) => ({
      key: String(key ?? '').trim(),
      label: String(label ?? '').trim()
    }))
    .filter(option => option.key)

export const getActiveCuisineFilterOptions = filters =>
  getActiveFilterOptions(filters, 'cuisine')

export const getActiveDietaryFilterOptions = filters =>
  getActiveFilterOptions(filters, 'dietary')

export const getActiveLocationLevels = (filters = {}) => {
  const locationData = filters?.locations || filters?.location || {}
  const levels = locationData.sections || locationData.levels || []

  return levels
    .map(level => {
      const label = resolveConcessionLocationTitle(level)
      const key = String(level?.key ?? '').trim()
      const sections = (level?.sections || [])
        .filter(section => section?.is_active !== false)
        .map(section => ({
          key: String(section?.key ?? '').trim(),
          label: String(section?.label ?? '').trim()
        }))
        .filter(section => section.key && section.label)

      return { key, label, sections }
    })
    .filter(level => level.key && level.label)
}

export const fetchConcessionFiltersByVenueId = async venueId => {
  if (!venueId) {
    return null
  }

  const { method, url } = concessionFiltersEndpoint.get(venueId)
  const idToken = getIdToken()
  const response = await fetch(url, {
    headers: { Authorization: `Bearer ${idToken}` },
    method
  }).then(async res => await getApiResponseInJSON(res))

  return response?.filters || null
}

export const fetchConcessionVendorFilterOptionsByVenueId = async venueId => {
  const filters = await fetchConcessionFiltersByVenueId(venueId)

  if (!filters) {
    return {
      cuisine: {
        options: [],
        placeholder: 'Select cuisine'
      },
      dietary: {
        options: [],
        placeholder: 'Select dietary preferences'
      },
      location: {
        levels: [],
        placeholder: 'All Levels'
      }
    }
  }

  const locationData = filters?.locations || filters?.location || {}

  return {
    cuisine: {
      options: getActiveCuisineFilterOptions(filters),
      placeholder: filters?.cuisine?.placeholder || 'Select cuisine'
    },
    dietary: {
      options: getActiveDietaryFilterOptions(filters),
      placeholder: filters?.dietary?.placeholder || 'Select dietary preferences'
    },
    location: {
      levels: getActiveLocationLevels(filters),
      placeholder: locationData?.placeholder || 'All Levels'
    }
  }
}

export const fetchConcessionDietaryFilterOptionsByVenueId = async venueId => {
  const { dietary } = await fetchConcessionVendorFilterOptionsByVenueId(venueId)
  return dietary
}
